import React from 'react';
import { Grid } from '@material-ui/core';
import { ButtonUI, CustomCardUI } from '../../common';

const Acordar = (props) => {
  const {
    metodos_envio,
    forms,
    handleActivarAcordarSubmit,
    handleDesactivarAcordarSubmit,
  } = props;

  const cargarBoton = () => {
    if (metodos_envio.me_acordar) {
      return (
        <ButtonUI
          type="callf"
          onClickFunc={handleDesactivarAcordarSubmit}
          label="DESACTIVAR"
          size="large"
          isLoading={forms.desactivar_acordar}
        />
      );
    } else {
      return (
        <ButtonUI
          type="callf"
          onClickFunc={handleActivarAcordarSubmit}
          label="ACTIVAR"
          size="large"
          isLoading={forms.activar_acordar}
        />
      );
    }
  };

  return (
    <Grid item lg={4} sm={6} xs={12}>
      <CustomCardUI
        title="Acordar"
        subtitle={
          metodos_envio.me_acordar ? 'Método activo' : 'Método no activo'
        }
        info="Te permitirá acordar un envío con tu comprador luego de la venta."
        image="https://dk0k1i3js6c49.cloudfront.net/panel/medios_envio/acordar-card-img.png"
      >
        {cargarBoton()}
      </CustomCardUI>
    </Grid>
  );
};

export { Acordar };
